module.exports = __webpack_public_path__ + "static/img/london2.432f6fd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cities/london2.jpg
// module id = 103
// module chunks = 9